module.exports = __webpack_public_path__ + "img/visa.6a60af42.svg";